// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1qQks","range":"MonthRangeSwitch_range__b__kV","disabled":"MonthRangeSwitch_disabled__1SD3T"};